export interface SalesOrderAnalysis {
  agent: string;
  agentName: string;
  orderMonthNumber: number;
  orderMonthName: string;
  weekNo: number;
  year: number;
  dateOrdered: Date;
  dateEntered: Date;
  orderNo: string;
  customerOrderRef: string;
  remake: string;
  orderType: string;
  customerKey: string;
  customerName: string;
  internalCustomer: string;
  brand: string;
  customerCategory: string;
  vatRegNumber: string;
  country: string;
  customerOrderNo: string;
  contractNo: number;
  preBuyOrder: string;
  fromPreBuyOrder: string;
  productType: string;
  productKey: string;
  oldCode: string;
  productDescription: string;
  makeUp: string;
  customerLineRef: string;
  internalNotes: string;
  noOfItems: number;
  quantity: number;
  despatchedQty: number;
  balance: number;
  balanceSterlingValue: number;
  unitOfMeasure: string;
  priceListQty: number;
  conversionUnitOfMeasure: string;
  price: number;
  discount: number;
  discountAmount: number;
  currencyCode: string;
  currencyValue: number;
  currencyDiscountValue: number;
  rate: number;
  sterlingValue: number;
  sterlingDiscountValue: number;
  commission: number;
  commissionValue: number;
  deliveryDate: Date;
  promisedDate: Date;
  reserved: string;
  reservationExpiryDate: Date;
  customerType: string;
  customerSubType: string;
  salesDiscount: string;
  costPrice: number;
  costValue: number;
  margin: number;
  marginPercentage: number;
  despatchNoteNo: number;
  despatchDate: Date;
  invoiceNo: number;
  dateInvoiced: Date;
  shipper: string;
  paymentTerms: string;
  proforma: string;
  proformaPrinted: string;
  proformaPrintedDate: Date;
  proformaPaid: string;
  proformaPaidDate: Date;
  deliveryTerms: string;
  settlementTerms: string;
  modeOfTransport: string;
  orderSource: string;
  orderStatus: string;
  sellingCompany: string;
  enteredBy: string;
  customerContact: string;
  tax: string;
  port: string;
  certificationRequired: string;
  deliveryAddress: string;
  deliveryCountry: string;
  productGroup: string;
  productCategory: string;
  cRMRef: string;
  postcode: string;
  deliveryAddressee: string;
  exportOrder: string;
  paymentMethod: string;
  billingName: string;
  billingAddressee: string;
  billingAddress1: string;
  billingAddress2: string;
  billingAddress3: string;
  billingTownCity: string;
  billingRegion: string;
  billingPostCode: string;
  billingCountry: string;
  orderRef: number;
  billingAddress: string;
  deliveryName: string;
  deliveryAddress1: string;
  deliveryAddress2: string;
  deliveryAddress3: string;
  deliveryTownCity: string;
  deliveryRegion: string;
  deliveryPostCode: string;
}
